export default __webpack_public_path__ + "images/c52a6ffaf4ba78c9d3c2a66e1121c05c-parking_small.webp";